export default __webpack_public_path__ + "3ac34c4e201c75d6fcca1700e44f6acc.png";